import type { PickupRecordDraft } from '@/types'

type DraftWithLegacy = PickupRecordDraft & { recorded_at?: string }

export function getDraftStartedAt(draft: DraftWithLegacy): string {
  return draft.started_at ?? draft.recorded_at ?? ''
}
